export enum COUPON_TYPE {
  NONE = 'NONE',
  FIXED = 'FIXED',
  FLOATING = 'FLOATING',
  FIXED_TO_FLOATING = 'FIXED_TO_FLOATING',
  FLOATING_TO_FIXED = 'FLOATING_TO_FIXED',
  SNOWBALL = 'SNOWBALL',
  CONDITIONAL = 'CONDITIONAL',
  FIXED_TO_FORWARD = 'FIXED_TO_FORWARD',
  FORWARD = 'FORWARD',
  CALL = 'CALL',
  FIXED_TO_CALL = 'FIXED_TO_CALL',
  DIGITAL = 'DIGITAL',
  FIXED_TO_DIGITAL = 'FIXED_TO_DIGITAL',
  LOWEST_FX_PERFORMANCE = 'LOWEST_FX_PERFORMANCE',
  RANGE_ACCRUAL = 'RANGE_ACCRUAL',
  FIXED_TO_RANGE_ACCRUAL = 'FIXED_TO_RANGE_ACCRUAL',
  FIXED_AND_CONDITIONAL = 'FIXED_AND_CONDITIONAL',
  // TODO: Still waiting for more details from Stuart/James/Ben
  // FIXED_TO_CONDITIONAL = 'FIXED_TO_CONDITIONAL',
  // FLOATING_TO_FIXED = 'FLOATING_TO_FIXED',
  // FIXED_TO_FLOATING_SWITCHABLE = 'FIXED_TO_FLOATING_SWITCHABLE',
  // DIGITAL = 'DIGITAL',
  // CALL = 'CALL',
}
